import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_workrelated_diseases_in_the_last_12_months'

export const dataPointDefinition = {
  retracedId: 'num_of_workrelated_diseases_in_the_last_12_months',
  name: 'Number of work-related diseases in the last 12 months:',
  description:
    'Work-related diseases may be caused by physical, chemical or biological factors, and arise due to:\r\r\n- the type of work performed by the worker; or\r\r\n- the surroundings in which the worker works.\r\r\n\r\r\nIn garment factories, legally defined work-related diseases include, e.g., benzene poisoning; byssinosis (a lung disease caused by textile fiber dust); skin inflammation/ ulceration due to exposure to dust, liquid or vapor; asthma or deafness.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-21',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17090,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
